/** Login form */
export const POLICY_ID_PATTERN = /[0-9]/;

/** Otp-verification */
export const OTP_CODE_PATTERN = '^[0-9]{6}$';
